import {
  COLLATERAL_MORTGAGE_TRANSLATION_TYPE,
  COLLATERAL_MORTGAGE_TRANSLATION_VALUE,
  getCollateralMortgageTransCode,
} from "pages/file/utils/products/collateralMortgage";
import { useWatch } from "react-hook-form";
import {
  selectTranslationList,
  useTranslationLists,
} from "utils/context/TranslationContext";

// The Collateral Mortgage trans code configured for the file's property state, or "" when
// the state has no configured row. The list itself is fetched once in CreateFile; this only
// reads it, so it is safe to call from as many jackets as the file has.
const useCollateralMortgageTransCode = (): string => {
  const [translationLists] = useTranslationLists();
  const stateAbbr: string = useWatch({ name: "properties.0.state.abbr" });

  return getCollateralMortgageTransCode(
    selectTranslationList(
      translationLists,
      COLLATERAL_MORTGAGE_TRANSLATION_TYPE,
      COLLATERAL_MORTGAGE_TRANSLATION_VALUE
    ),
    stateAbbr
  );
};

// Distinguishes "no collateral trans code configured for this state" from "the translation
// list has not come back yet" — both look like "" to the resolver above, but only the first
// should be allowed to drive a value onto the form.
export const useIsCollateralMortgageConfigLoaded = (): boolean => {
  const [translationLists] = useTranslationLists();

  return Boolean(
    selectTranslationList(
      translationLists,
      COLLATERAL_MORTGAGE_TRANSLATION_TYPE,
      COLLATERAL_MORTGAGE_TRANSLATION_VALUE
    )
  );
};

export default useCollateralMortgageTransCode;
